import { objectToQueryParams } from '../../utils/format';
import { getAntiForgeryToken } from '../authApi/authAPI';
import { ApiCore } from '../utils/core';
import type {
  GetGroupMembersParams,
  LegacyGetGroupsQuery,
  GroupViewModelExtended,
  GroupMemberViewModel,
} from './types';

const legacyGroupsApi = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  remove: false,
  singleExtra: true,
  url: 'Groups',
});

export const getGroups = (query?: LegacyGetGroupsQuery) => {
  return legacyGroupsApi.performExtra<GroupViewModelExtended[]>({
    method: 'get',
    extraResource: `?${objectToQueryParams(query as Record<string, string | number | boolean>)}`,
  });
};

export const deleteMember = async () => {
  await getAntiForgeryToken();
};

export const getGroupById = (id: number) => {
  return legacyGroupsApi.getSingle<GroupViewModelExtended>(id);
};

export const getGroupMembers = (params: GetGroupMembersParams) => {
  const { id, query } = params;
  return legacyGroupsApi.performExtra<GroupMemberViewModel[]>({
    extraResource: `members?${objectToQueryParams(query)}`,
    method: 'GET',
    id: id,
  });
};
